export default __webpack_public_path__ + "static/media/dviya.e623478c.jpg";